import trackUtil from '@/utils/analytics-service';
import { buildAnalyticsContext } from '@/hooks/useAnalyticsContext';
import {
  OnboardingPath,
  SchemaAction,
  SchemaModifiedProps,
  SchemaObjectType,
  SchemaSurface,
} from '@/utils/analytics/types';
import type { JourneyName } from '@/utils/analytics/taxonomy';
import { WorkspaceT } from '@/pages/workgroup/type';

type SchemaModifiedInput = {
  schema_object_type: SchemaObjectType;
  schema_action: SchemaAction;
  attribute_changed: boolean;
  schema_surface: SchemaSurface;
  onboarding_path?: OnboardingPath;
  journey_name?: JourneyName;
};

export function trackSchemaModifiedEvent(
  props: SchemaModifiedInput,
  sources: {
    userId?: string;
    organizationId?: string;
    workspace: WorkspaceT;
    graphId: string;
  }
) {
  const context = buildAnalyticsContext(
    {},
    {
      userId: sources.userId,
      organizationId: sources.organizationId,
      workspace: sources.workspace,
      graphId: sources.graphId,
    }
  );

  const { user_id, organization_id, workgroup_id, workspace_id, database_id, graph_id } = context;

  if (!user_id || !organization_id || !workgroup_id || !database_id || !workspace_id || !graph_id) {
    return;
  }

  const payload: SchemaModifiedProps = {
    user_id,
    organization_id,
    workgroup_id,
    database_id,
    workspace_id,
    graph_id,
    schema_object_type: props.schema_object_type,
    schema_action: props.schema_action,
    attribute_changed: props.attribute_changed,
    schema_surface: props.schema_surface,
    onboarding_path: props.onboarding_path,
    journey_name: props.journey_name,
  };

  trackUtil.trackSchemaModified(payload);
}
